import React, { useEffect, useState, useRef } from 'react';

const Modal = ({ isOpen, onClose, title, children, size = 'max-w-4xl' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const closeTimerRef = useRef(null);
  const openTimerRef = useRef(null);

  useEffect(() => {
    // Clear any existing timers
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    if (openTimerRef.current) {
      clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }

    if (isOpen) {
      // Opening: render first, then animate in
      setShouldRender(true);
      openTimerRef.current = setTimeout(() => {
        setIsVisible(true);
      }, 50);
    } else if (shouldRender) {
      // Closing: animate out first, then unmount
      setIsVisible(false);
      closeTimerRef.current = setTimeout(() => {
        setShouldRender(false);
      }, 450); // Wait for animation to complete
    }

    return () => {
      if (openTimerRef.current) clearTimeout(openTimerRef.current);
      // Don't clear closeTimer on cleanup - let the animation finish
    };
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop with slow fade */}
      <div
        className={`fixed inset-0 bg-black transition-all duration-[400ms] ease-out ${isVisible ? 'bg-opacity-20' : 'bg-opacity-0'
          }`}
        onClick={onClose}
      />

      {/* Sliding Panel with fade + slide */}
      <div
        className={`fixed right-0 top-[64px] h-[calc(100vh-88px)] w-3/4 bg-white shadow-2xl 
          transition-all duration-[400ms] ease-out
          ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
          flex flex-col rounded-l-xl rounded-bl-xl overflow-hidden`}
      >
        {/* Header - only render if title exists */}
        {title && (
          <div className="flex items-center gap-3 px-6 py-3 border-b bg-white flex-shrink-0">
            <button
              onClick={onClose}
              className="p-1.5 -ml-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-all focus:outline-none"
              aria-label="Back"
              title="Close"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </button>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
        )}

        {/* Content - children handle their own scrolling */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;